export default "__VITE_ASSET__c4613c70__"